'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_Content = exports.bpfrpt_proptype_Context = exports.bpfrpt_proptype_Status = undefined;

var _constants = require('./constants');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bpfrpt_proptype_Status = _propTypes2.default.oneOfType([_propTypes2.default.any, _propTypes2.default.any, _propTypes2.default.any, _propTypes2.default.any, _propTypes2.default.any]);

var bpfrpt_proptype_Context = {
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  extra: _propTypes2.default.shape({
    children: function children() {
      return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
    },
    icon: _propTypes2.default.string,
    renderIcon: _propTypes2.default.func
  }),
  renderExtra: _propTypes2.default.func,
  error: _propTypes2.default.string
};
var bpfrpt_proptype_Content = {
  default: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    description: _propTypes2.default.string,
    extra: _propTypes2.default.shape({
      children: function children() {
        return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
      },
      icon: _propTypes2.default.string,
      renderIcon: _propTypes2.default.func
    }),
    renderExtra: _propTypes2.default.func,
    error: _propTypes2.default.string
  }),
  uploading: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    description: _propTypes2.default.string,
    extra: _propTypes2.default.shape({
      children: function children() {
        return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
      },
      icon: _propTypes2.default.string,
      renderIcon: _propTypes2.default.func
    }),
    renderExtra: _propTypes2.default.func,
    error: _propTypes2.default.string
  }),
  success: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    description: _propTypes2.default.string,
    extra: _propTypes2.default.shape({
      children: function children() {
        return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
      },
      icon: _propTypes2.default.string,
      renderIcon: _propTypes2.default.func
    }),
    renderExtra: _propTypes2.default.func,
    error: _propTypes2.default.string
  }),
  error: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    description: _propTypes2.default.string,
    extra: _propTypes2.default.shape({
      children: function children() {
        return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
      },
      icon: _propTypes2.default.string,
      renderIcon: _propTypes2.default.func
    }),
    renderExtra: _propTypes2.default.func,
    error: _propTypes2.default.string
  }),
  disabled: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    description: _propTypes2.default.string,
    extra: _propTypes2.default.shape({
      children: function children() {
        return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
      },
      icon: _propTypes2.default.string,
      renderIcon: _propTypes2.default.func
    }),
    renderExtra: _propTypes2.default.func,
    error: _propTypes2.default.string
  })
};
exports.bpfrpt_proptype_Status = bpfrpt_proptype_Status;
exports.bpfrpt_proptype_Context = bpfrpt_proptype_Context;
exports.bpfrpt_proptype_Content = bpfrpt_proptype_Content;